import { actions } from "./Reducer";

/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingArtisanJobAction = (body) => ({
  type: actions.UPDATE_PENDING_ARTISAN_JOB,
  payload: body,
});

// Plural
export const getPendingArtisanJobsAction = (body) => ({
  type: actions.GET_PENDING_ARTISAN_JOBS,
  payload: body,
});


/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const updatePendingArtisanJobSuccessAction = (job) => ({
  type: actions.UPDATE_PENDING_ARTISAN_JOB_SUCCESS,
  payload: job,
});

// Plural
export const getPendingArtisanJobsSuccessAction = (jobs) => ({
  type: actions.GET_PENDING_ARTISAN_JOBS_SUCCESS,
  payload: jobs,
});

export const getSinglePendingArtisanJobAction = (id) => ({
  type: actions.GET_SINGLE_PENDING_ARTISAN_JOB,
  payload: id 
})

export const deleteSinglePendingArtisanProdcutAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_ARTISAN_JOB,
  payload: id
})

export const moderateCreateSinglePendingArtisanJobAction = (id, mode) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN_JOB,
  payload: id,
  mode
})
/**
 * Misc
 */

export const setPendingArtisanJobsIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_ARTISAN_JOBS_IS_LOADING,
  payload: isLoading,
});

export const setPendingArtisanJobsCountAction = (count) => ({
  type: actions.SET_PENDING_ARTISAN_JOBS_COUNT,
  payload: count,
});

export const getSinglePendingArtisanJobSuccessAction = (job) => ({
  type: actions.GET_SINGLE_PENDING_ARTISAN_JOB_SUCCESS,
  payload: job
})

export const deleteSinglePendingArtisanJobSuccessAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_ARTISAN_JOB_SUCCESS,
  payload: id
})

export const moderateCreateSinglePendingArtisanJobSuccessAction = (id) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN_JOB_SUCCESS,
  payload: id
})